import React from 'react';
import "./Footer.css";

 export function Footer() {
  return (
    <div className="footer">
      <p>Developed by <span> Rakesh Kumar</span></p>
      <p>Built with <span>React JS</span> </p>
      <p>Hosted on <span>Netlify</span> </p>
    </div>
  )
}

